module.exports = __webpack_public_path__ + "img/banner-16.087b0bf3.jpg";